






























import { Component, Vue } from 'vue-property-decorator'
import { downloadState } from '../../store/modules/DownloadState'
import { Conditions } from '../../modules/class/PdfDownload/Conditions'
import { DownloadLinkInfo } from '../../modules/class/Downloads'
import PdfList from '../../components/PdfLink/PdfList.vue'
import PdfTable from '../../components/PdfLink/PdfTable.vue'
import PdfFIlter from '../../components/PdfLink/PdfFIlter.vue'
import Accordion from '../../components/Parts/Accordion.vue'

@Component({
  components: { PdfList, PdfTable, Accordion, PdfFIlter }
})
export default class PdfDownloadTableFull extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data

  // 抽出条件（main.tsから連携される）
  private conditions: Conditions = new Conditions()
  private pdfList: DownloadLinkInfo[] = []

  // PDFタイトルのフィルタキーワード
  private filterKeyword = ''

  // --------------------------------------------------------------------------------------------------------------------
  // computed

  /**
   * アコーディオンを利用するかの可否
   */
  get useAccordion(): boolean {
    return this.pdfList.length > 10
  }

  /**
   * PDFタイトルでフィルタリングした結果のリスト
   */
  get filterPdfList(): DownloadLinkInfo[] {
    const list = [...this.pdfList]

    if (this.filterKeyword.length === 0) {
      return list
    }

    const keyword = this.filterKeyword.toLowerCase()
    return list.filter((p) => {
      return p.title.toLowerCase().includes(keyword)
    })
  }

  /**
   * サジェストに表示する対象
   */
  get suggest(): string[] {
    return this.pdfList.map((i) => i.title)
  }

  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * コンポーネントから渡された一覧を更新
   */
  private updatePdfList(data: DownloadLinkInfo[]) {
    this.pdfList = data

    // アンカーリンクを追加
    if (this.pdfList.length > 0) {
      downloadState.setAnchor(this.conditions.anchor)
    }
  }

  /**
   * 検索
   */
  private search(keyword: string) {
    this.filterKeyword = keyword
    this.openAccordion()
  }

  /**
   * アコーディオンを開く
   */
  private openAccordion() {
    const target = this.$refs.accordion as Element as HTMLElement
    const more = target.querySelector(
      '.c-textAccordion__button--more.is-active'
    )
    if (more) {
      more.dispatchEvent(new Event('click'))
    }
  }
}
